import { logPush } from './logBus';

export function installGlobalErrorHooks() {
  if (window.__errorHooksInstalled) return;
  window.__errorHooksInstalled = true;

  // JS runtime errors
  window.addEventListener('error', (e) => {
    logPush({
      level: 'error',
      message: e.message || 'Unhandled error',
      stack: e.error?.stack || `${e.filename}:${e.lineno}:${e.colno}`,
      meta: { type: 'window.onerror' }
    });
  });

  // Unhandled Promise rejections
  window.addEventListener('unhandledrejection', (e) => {
    const reason = e.reason;
    logPush({
      level: 'error',
      message: (reason && (reason.message || String(reason))) || 'Unhandled rejection',
      stack: reason?.stack || null,
      meta: { type: 'unhandledrejection' }
    });
  });

  // Mirror console.error/warn/info to the buffer
  ['error', 'warn', 'info'].forEach(level => {
    const orig = console[level].bind(console);
    console[level] = (...args) => {
      // Prevent infinite loop if logPush itself calls console.error
      if (args[0] === '[APP]') {
        orig(...args);
        return;
      }
      const message = args.map(a => (a && a.stack) ? a.stack : (typeof a === 'string' ? a : JSON.stringify(a))).join(' ');
      logPush({ level, message });
      orig(...args);
    };
  });
}